import { useState } from "react";
import { OptionRawSelect } from "@/ui/organisms/Form/RawSelect";
import { PeriodType } from "../utils/periodAggregation";

export interface UsePeriodFilterReturn {
    selectedPeriod: OptionRawSelect;
    periodOptions: OptionRawSelect[];
    handlePeriodChange: (option: OptionRawSelect | OptionRawSelect[]) => void;
    periodFilterProps: {
        selectedPeriod: OptionRawSelect;
        onPeriodChange: (option: OptionRawSelect | OptionRawSelect[]) => void;
        options: OptionRawSelect[];
    };
}

export function usePeriodFilter(
    defaultPeriod: PeriodType = "monthly",
): UsePeriodFilterReturn {
    const periodOptions: OptionRawSelect[] = [
        { label: "Monthly", value: "monthly" },
        { label: "Quarterly", value: "quarterly" },
        { label: "Yearly", value: "yearly" },
    ];

    const defaultOption =
        periodOptions.find((option) => option.value === defaultPeriod) ||
        periodOptions[0];
    const [selectedPeriod, setSelectedPeriod] =
        useState<OptionRawSelect>(defaultOption);

    const handlePeriodChange = (
        option: OptionRawSelect | OptionRawSelect[],
    ) => {
        if (Array.isArray(option)) {
            setSelectedPeriod(option[0]);
        } else {
            setSelectedPeriod(option);
        }
    };

    return {
        selectedPeriod,
        periodOptions,
        handlePeriodChange,
        periodFilterProps: {
            selectedPeriod,
            onPeriodChange: handlePeriodChange,
            options: periodOptions,
        },
    };
}
